import { type ReactNode } from 'react';

import {
  ElectricityIcon,
  GasIcon,
  GiftIcon,
  WarmthIcon,
  WaterIcon,
  ColdIcon,
  HeatingIcon,
  RedeliveryIcon,
} from '@eneco/sparky/icons';

import { DetailsType } from '../../types';

export const typeTheme: Record<DetailsType, { backgroundColor: string; textColor: string; icon?: ReactNode }> = {
  [DetailsType.Gas]: {
    backgroundColor: 'backgroundVarOne',
    textColor: 'textOnBackgroundVarOne',
    icon: <GasIcon color="iconGasNew" />,
  },
  [DetailsType.Water]: {
    backgroundColor: 'backgroundVarThree',
    textColor: 'textOnBackgroundVarThree',
    icon: <WaterIcon color="iconCooling" />,
  },
  [DetailsType.TapWater]: {
    backgroundColor: 'backgroundVarThree',
    textColor: 'textOnBackgroundVarThree',
    icon: <WaterIcon color="iconWaterNew" />,
  },
  [DetailsType.Cooling]: {
    backgroundColor: 'backgroundVarOne',
    textColor: 'textOnBackgroundVarOne',
    icon: <ColdIcon color="iconCoolingNew" />,
  },
  [DetailsType.Warmth]: {
    backgroundColor: 'backgroundVarTwo',
    textColor: 'textOnBackgroundVarTwo',
    icon: <WarmthIcon color="iconHeatNew" />,
  },
  [DetailsType.Warmtewisselaar]: {
    backgroundColor: 'backgroundVarTwo',
    textColor: 'textOnBackgroundVarTwo',
    icon: <HeatingIcon color="iconHeatNew" />,
  },
  [DetailsType.Redelivery]: {
    backgroundColor: 'backgroundVarFive',
    textColor: 'textOnBackgroundVarFive',
    icon: <RedeliveryIcon color="iconSolar" />,
  },
  [DetailsType.Electricity]: {
    backgroundColor: 'backgroundVarFive',
    textColor: 'textOnBackgroundVarFive',
    icon: <ElectricityIcon color="iconElectricityNew" />,
  },
  [DetailsType.Cashback]: {
    backgroundColor: 'backgroundVarOne',
    textColor: 'textOnBackgroundVarOne',
    icon: <GiftIcon color="iconOnBackgroundVarOne" />,
  },
  [DetailsType.TotalCosts]: {
    backgroundColor: 'backgroundTertiary',
    textColor: 'textOnBackgroundTertiary',
  },
};
